import _app from "../../../views/_app.tsx";

/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "404": dynamic(() => import("../../../views/404.tsx"), "views/404.tsx"),
  "_app": _app,
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "single": dynamic(() => import("../../../views/single.tsx"), "views/single.tsx"),
  "single-jobs": dynamic(() => import("../../../views/single-jobs.tsx"), "views/single-jobs.tsx"),
  "single-journal": dynamic(() => import("../../../views/single-journal.tsx"), "views/single-journal.tsx"),
  "single-project": dynamic(() => import("../../../views/single-project.tsx"), "views/single-project.tsx"),
  "template-about": dynamic(() => import("../../../views/template-about.tsx"), "views/template-about.tsx"),
  "template-home": dynamic(() => import("../../../views/template-home.tsx"), "views/template-home.tsx"),
  "template-jobs": dynamic(() => import("../../../views/template-jobs.tsx"), "views/template-jobs.tsx"),
  "template-journal": dynamic(() => import("../../../views/template-journal.tsx"), "views/template-journal.tsx"),
  "template-people": dynamic(() => import("../../../views/template-people.tsx"), "views/template-people.tsx"),
  "template-projects": dynamic(() => import("../../../views/template-projects.tsx"), "views/template-projects.tsx"),
  "template-search": dynamic(() => import("../../../views/template-search.tsx"), "views/template-search.tsx"),
  "template-studios": dynamic(() => import("../../../views/template-studios.tsx"), "views/template-studios.tsx"),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
